import { useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface IMyProps {
  show: boolean;
  initialValue: number;
  handleAplicar: (valor: number) => void;
  handleHide: (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
      | HTMLElement,
  ) => void;
}

export default function ModelEditarMaximoEstagiarios({
  show,
  initialValue,
  handleHide,
  handleAplicar,
}: IMyProps) {
  const valor = useRef<HTMLInputElement>(null);

  return (
    <Modal
      show={show}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onExit={handleHide}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Máximo de estagiários.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <input
            className="form-control col-md-6"
            ref={valor}
            type="number"
            min={0}
            max={100}
            defaultValue={initialValue}
          />
        </p>
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button
          variant="success"
          onClick={() => {
            handleAplicar(Number(valor.current!.value));
          }}
        >
          Aplicar
        </Button>
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
